import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const navLinks = [
{ name: 'About', href: '#about' },
{ name: 'Ecosystem', href: '#ecosystem' },
{ name: 'Companies', href: '#companies' },
{ name: 'Fashion & Culture', href: '#fashion' },
{ name: 'Technology', href: '#technology' },
{ name: 'Vision', href: '#vision' },
{ name: 'Contact', href: '#contact' }];


export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <header
        data-testid="main-header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ?
        'bg-[#F9F6F0]/90 backdrop-blur-xl border-b border-black/10' :
        'bg-transparent'}`
        }>

        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <motion.a
              href="#"
              data-testid="logo-link"
              className="font-heading tracking-[0.1em]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}>

              <div className="flex flex-col items-center leading-none">
                <span className={`font-medium text-2xl lg:text-3xl transition-colors duration-300 tracking-[0.2em] ${isScrolled ? 'text-[#1A1A1A]' : 'text-[#F9F6F0]'}`}>
                  HEMRAJ
                </span>
                <span className={`font-normal text-[8px] lg:text-[10px] transition-colors duration-300 tracking-[0.45em] lg:tracking-[0.5em] ${isScrolled ? 'text-[#1A1A1A]' : 'text-[#F9F6F0]'}`}>
                  GRANDSONS
                </span>
              </div>
            </motion.a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link, index) =>
              <motion.button
                key={link.name}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                onClick={() => scrollToSection(link.href)}
                className={`nav-link text-sm tracking-wide transition-colors duration-300 ${
                isScrolled ?
                'text-[#4A4A4A] hover:text-[#1A1A1A]' :
                'text-[#F9F6F0]/80 hover:text-[#F9F6F0]'}`
                }
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}>

                  {link.name}
                </motion.button>
              )}
            </nav>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-button"
              className="lg:hidden p-2"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

              {isMobileMenuOpen ?
              <X className={isScrolled ? 'text-[#1A1A1A]' : 'text-[#F9F6F0]'} size={24} /> :

              <Menu className={isScrolled ? 'text-[#1A1A1A]' : 'text-[#F9F6F0]'} size={24} />
              }
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen &&
        <motion.div
          data-testid="mobile-menu"
          className="fixed inset-0 z-40 bg-[#F9F6F0] pt-20"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}>

            <nav className="flex flex-col items-center justify-center h-full gap-8">
              {navLinks.map((link, index) =>
            <motion.button
              key={link.name}
              data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              onClick={() => scrollToSection(link.href)}
              className="font-heading text-3xl font-light text-[#1A1A1A] hover:text-[#C5A880] transition-colors"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}>

                  {link.name}
                </motion.button>
            )}
            </nav>
          </motion.div>
        }
      </AnimatePresence>
    </>);

};